import { container } from "tsyringe";
import TeamApi from "api/clapaction/projects/[id]/config/team/TeamApi";
import ProjectTeamServiceClassToken from "common/resources/injectables/ProjectTeamServiceClassToken";
import ProjectTeamResponseResource from "common/resources/Project/Config/Team/ProjectTeamResponseResource";
import toValidationError from "utils/toValidationError";

export default class TeamService implements ProjectTeamServiceClassToken {
	private api: TeamApi = container.resolve(TeamApi);

	/**
	 * @description Check if a project team exists by id
	 */
	public async exists(_id: string): Promise<boolean> {
		return true;
	}

	/**
	 * @description Get by project id
	 */
	public async getByProjectId(projectId: string): Promise<ProjectTeamResponseResource> {
		return this.api.getByProjectId(projectId).catch(toValidationError);
	}

	/**
	 * @description Create an empty project team, or get the existing one
	 */
	public async create(projectId: string): Promise<ProjectTeamResponseResource> {
		return this.api.create(projectId).catch(toValidationError);
	}
}
